module.exports = __webpack_public_path__ + "static/img/IMG_0354.afdac37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/IMG_0354.jpg
// module id = RZjE
// module chunks = 1